module.exports = __webpack_public_path__ + "img/range.25439f78.svg";